/**
 * A reference target that spells ITSELF (`render_config.format_from`).
 *
 * Some lookup families hold the sentence their referrers should print, with a
 * `%s` where each of the link's own values goes: `specialfeatprerequisite/bab-x`
 * carries "Base attack bonus +%s" and a feat's link to it carries
 * `value_1: "3"`. The API ships that string as `display_format` on the target
 * whenever the REFERRING attribute declares which target attribute holds it
 * (`db/mrcs/README.md`, "a reference target that spells itself").
 *
 * Without it a renderer can only print the target's NAME followed by the raw
 * values, and 328 feat prerequisites read "BAB +x 3", "Sneak attack Xd6 2" and
 * "Skirmish +Xd6/+Y AC 2 1" — the interpolation was `FeatDetail.js`'s and it was
 * lost when that page was deleted in the P4 renderer collapse, having been
 * authored for it since P2 (authoring call 22).
 *
 * It lives here, alone, because THREE renderers must agree about it — the
 * labelled row (`AttrValue`), the link list (`DetailSection`) and the copy
 * formatter (`formatEntry`) — and a value that reads differently in two places
 * is the defect this codebase keeps a single seam to prevent.
 *
 * Holes are filled from the attribute's own declared link data in display
 * order; a hole with no value left renders empty rather than "undefined".
 */
export default function displayFormatText(attr, target) {
  const format = target && target.display_format;
  if (typeof format !== 'string' || !format) return null;
  const values = ((attr && attr.linkData) || [])
    .map((field) => target[field.key])
    .filter((v) => v !== undefined && v !== null && v !== '');
  let i = 0;
  return format.replace(/%s/g, () => {
    const value = values[i];
    i += 1;
    return value === undefined ? '' : String(value);
  });
}
